import { RecoApis }                       from "apis/recoAPI";
import { useGlobalConfig }                from "context/GlobalContext";
import { useSelector, 
         useDispatch 
       }                                  from "react-redux";
import { CMSPilotsReducerState }          from "store/dataReducers/cmsPilotSlice";
import RecommendationsTable               from "./RecoTableComponent";
import { BglPrimaryButton, 
         BglPrimarySmallButton 
       }                                  from "components/button/BglButtons";
import AddIcon                            from '@mui/icons-material/Add';
import RefreshIcon                        from '@mui/icons-material/Refresh';
import { useEffect, 
         useState 
       }                                  from "react";
import { RecoReducerState, 
         setRecoError, 
         setRecos, 
         setReviewWorkflowAction
       }                                  from "store/dataReducers/recommendationsSlice";
import { RootState }                      from "store/Store";
import { Card , 
         Typography,
         CircularProgress, 
         Box
       }                                  from "@mui/material";
import { ROUTE_TREE }                     from "routes/AppRoutes";
import { BglLoading }                     from "components/loading";

export const RecoHomePage = () => {

  const dispatch = useDispatch();

  const { rc } = useGlobalConfig();

  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const pilotState = useSelector((state : RootState) => state.cmsPilot) as CMSPilotsReducerState;
  
  const recoInitDone = useSelector((state : RootState) => (state.recommendations as RecoReducerState).initDone) as boolean;
  const recoCount = useSelector((state : RootState) => (state.recommendations as RecoReducerState).count);
  const error = useSelector((state : RootState) => (state.recommendations as RecoReducerState).error);
  const hasUnsavedRows = useSelector((state : RootState) => (state.recommendations as RecoReducerState).hasUnsavedRows);

  const getRecos = async () => {
    
    setIsLoading(true)

    const [reviewWorkflowResp, recoResp] = await Promise.all([
      RecoApis.getReviewWorkflow(rc),
      RecoApis.getRecosForUtility(rc, pilotState.selectedPilotDocId)
    ])

    if (reviewWorkflowResp.error || recoResp.error) {
      dispatch(setRecoError(reviewWorkflowResp.error || recoResp.error))
    } else {
      dispatch(setRecos({reco : recoResp.data, recoScore : pilotState.selectedPilotRecoScore}))
      dispatch(setReviewWorkflowAction(reviewWorkflowResp.data))
    }

    setIsLoading(false)
  }

  const handleRefresh = async () => {
    setIsRefreshing(true);
    
    const recoResp = await RecoApis.getRecosForUtility(rc, pilotState.selectedPilotDocId)
    
    if (recoResp.error) {
      dispatch(setRecoError(recoResp.error))
    } else {
      dispatch(setRecos({reco : recoResp.data, recoScore : pilotState.selectedPilotRecoScore}))
    }

    setIsRefreshing(false);
  }

  useEffect(() => {

    if (!recoInitDone) {
      getRecos()
    } else {
      setIsLoading(false)
    }
  })

  return (
    <>
    {
      isLoading ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><BglLoading /></Box>
      )
      
      : error ? 
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', 
          alignItems: 'center', marginTop: '20px'}}>
        <Typography variant="h6">{error.message}</Typography>
        <BglPrimaryButton
          onClick={() => getRecos()}>
          Retry
        </BglPrimaryButton>
      </div>

      : 
      <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '20px', 
        paddingLeft: '20px', height: '100%', overflowY: 'auto'}}>
          
          <Card style={{ padding: '15px', marginBottom: '20px', marginRight: '20px', overflow: 'unset' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', gap: '40px' }}>
                <div>
                  <Typography variant="subtitle2" color="textSecondary">Total</Typography>
                  <Typography variant="h6" color="error">{recoCount.draft + recoCount.published}</Typography>
                </div>
                <div>
                  <Typography variant="subtitle2" color="textSecondary">Disabled</Typography>
                  <Typography variant="h6" color="grey">{recoCount.disabled}</Typography>
                </div>
                
                <div>
                  <Typography variant="subtitle2" color="textSecondary">Draft</Typography>
                  <Typography variant="h6" color="warning">{recoCount.draft}</Typography>
                </div>
                <div>
                  <Typography variant="subtitle2" color="textSecondary">Modified</Typography>
                  <Typography variant="h6" color="primary">{recoCount.modified}</Typography>
                </div>
                <div>
                  <Typography variant="subtitle2" color="textSecondary">Published</Typography>
                  <Typography variant="h6" color="success">{recoCount.published}</Typography>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <BglPrimarySmallButton
                  startIcon={isRefreshing ? <CircularProgress size={16} color="inherit" /> : <RefreshIcon />}
                  onClick={() => handleRefresh()}
                  disabled={hasUnsavedRows || isRefreshing}>
                  {'Refresh'}
                </BglPrimarySmallButton>
                { rc.permissionsManager.canRecommendationCreate() &&
                  <BglPrimarySmallButton
                  startIcon={<AddIcon />}
                  onClick={() => rc.uiRouter.navigate(ROUTE_TREE.CMS.RECO.CREATE)}>
                  Add New
                </BglPrimarySmallButton>}
              </div>
            </div>
          </Card>

          <RecommendationsTable/> 
        
      </div>
    }
    
    </>
  )

}